import { ReactNode, useContext, useMemo } from 'react'
import './DatesModal.css'
import XmarkIcon from 'components/atoms/iconsComponent/XmarkIcon'
import { initialStateDatesResponse } from 'components/types/types'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import { useGuestView } from 'shared/GeneralContext/GuestContext'

interface DatesModalProps {
    children?: ReactNode
    modalIsOpen?: boolean
    setModalIsOpen: (param: boolean) => void
}

export const DatesModal = ({ children, modalIsOpen, setModalIsOpen }: DatesModalProps) => {
    const { setDateResponse, setstartUpIdforMatch } = useContext(AppGeneralContext)
    const { setCanMatch } = useGuestView()

    const { userGuest, resetGuest } = useGuestView()

    const close = () => {
        setModalIsOpen(false);
        setDateResponse(initialStateDatesResponse)
        setCanMatch(undefined)
        setstartUpIdforMatch("")
        if (userGuest) {
            resetGuest(true)
        }
    }

    const showModal = useMemo(() => {
        if (modalIsOpen) {
            return (
                <div className="d-flex modal justify-content-center align-items-center w-100  backdrop dates-modal "  >
                    <div className="d-flex flex-column relative h-100  dates_Modal_Container modal_overflow " >
                        <a className='close-button-dates absolute ' onClick={() => close()} href="#"><XmarkIcon className='close-button-dates ' /></a>
                        <div className='d-flex w-100 h-100 justify-content-center  '>
                            {children}
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }, [modalIsOpen])

    return showModal
}


